var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4 28c-1.6-.4-3.2-1.2-4.4-2.4-1.2-.4-1.6-1.6-1.6-2.4 0-.8.4-2 1.2-2.4 1.2-.8 2.4-1.6 3.6-1.2 2.4 0 4.4 1.2 5.6 2.8l3.6-4.8c-1.2-1.2-2.4-2-3.6-2.8-1.2-.8-2.8-1.2-4.4-1.2V8h-4.8v5.6c-2 .4-4 1.6-5.6 3.2-1.6 2-2.8 4.4-2.4 6.8 0 2.4.8 4.8 2.4 6.4 2 2 4.8 3.2 7.2 4.4 1.2.4 2.8 1.2 4 2 .8.8 1.2 2 1.2 3.2 0 1.2-.4 2.4-1.2 3.6-1.2 1.2-2.8 1.6-4 1.6-1.6 0-3.6-.4-4.8-1.6-1.2-.8-2.4-2-3.2-3.2l-4 4.4c1.2 1.6 2.4 2.8 4 4 2 1.2 4.4 2.4 6.8 2.4V56h4.4v-6c2.4-.4 4.4-1.6 6-3.2 2-2 3.2-5.2 3.2-8 0-2.4-.8-5.2-2.8-6.8-2-2-4-3.2-6.4-4zM32 0C14.4 0 0 14.4 0 32s14.4 32 32 32 32-14.4 32-32S49.6 0 32 0zm0 59.6C16.8 59.6 4.4 47.2 4.4 32 4.4 16.8 16.8 4.4 32 4.4c15.2 0 27.6 12.4 27.6 27.6 0 15.2-12.4 27.6-27.6 27.6z",
    fill: "#8098B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrices);
export default __webpack_public_path__ + "static/media/prices.29f0883f56dbaee78f83aa329d77fbc1.svg";
export { ForwardRef as ReactComponent };